// extracted by mini-css-extract-plugin
export var closeButton = "_5r-0";